import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4dd3187e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=4dd3187e&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=4dd3187e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.7.4_webpack@5.102.1__ejs@3.1.1_8e3b2d983739573c8a37493d5fe535f8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3187e",
  null
  
)

export default component.exports